import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, createContext, useContext } from 'react';
import { DeviceProvider as SeagullDeviceProvider } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
const RootDeviceContext = /*#__PURE__*/ createContext({
    isMobileDevice: false,
    isNativeApp: false
});
export function RootDeviceProvider(param) {
    let { children, isMobileDevice, isNativeApp } = param;
    const value = useMemo(()=>({
            isMobileDevice,
            isNativeApp
        }), [
        isMobileDevice,
        isNativeApp
    ]);
    return /*#__PURE__*/ _jsx(RootDeviceContext.Provider, {
        value: value,
        children: children
    });
}
export const useRootDevice = ()=>useContext(RootDeviceContext);
export function AppDeviceProvider(param) {
    let { children, isMobileDevice } = param;
    const value = useSeagullDevice(isMobileDevice);
    return /*#__PURE__*/ _jsx(SeagullDeviceProvider, {
        value: value,
        children: children
    });
}
function useSeagullDevice(isMobileDeviceOverride) {
    const { isMobileDevice, isNativeApp } = useRootDevice();
    const { PULL_TO_REFRESH } = useFeatureFlags();
    const isMobile = isMobileDeviceOverride !== null && isMobileDeviceOverride !== void 0 ? isMobileDeviceOverride : isMobileDevice;
    return useMemo(()=>({
            isMobileDevice: isMobile,
            supportsPullToRefresh: isNativeApp && PULL_TO_REFRESH
        }), [
        isMobile,
        isNativeApp,
        PULL_TO_REFRESH
    ]);
}
export function withDeviceProvider(Component) {
    return function WithDeviceProvider(props) {
        return /*#__PURE__*/ _jsx(AppDeviceProvider, {
            children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
        });
    };
}
